import { Separator } from "@app/components/core/Separator/Separator"
import { useGetStrings, useGetUpsellArticles } from "@app/store/service/cmsService"
import { ORDER_LINE_TYPES } from "@app/utils/constants"
import { useSelector } from "@tecreation/js-state-react"
import Entrance from "../Entrance/Entrance"

const getEntranceLines = (formattedOrder, withParkingTickets) => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { data: loadedParkingTickets } = useGetUpsellArticles()

	const isNotInParkingTickets = detail =>
		withParkingTickets ? true : loadedParkingTickets && detail.ticketId ? loadedParkingTickets.filter(e => e.ticketId == detail.ticketId).length === 0 : true

	const isEntranceType = detail => {
		const detailType = detail.originalTypeId || detail.typeId
		return (
			detailType === ORDER_LINE_TYPES.Ticket ||
			detailType === ORDER_LINE_TYPES.Activity ||
			detailType === ORDER_LINE_TYPES.Object ||
			detailType === ORDER_LINE_TYPES.ObjectGroup
		)
	}

	const lines = []
	formattedOrder.orderLines.forEach(orderLine => {
		let details = orderLine.details.filter(e => isEntranceType(e) && isNotInParkingTickets(e))
		if (details.length > 0) {
			lines.push({
				...orderLine,
				details,
			})
		}
	})

	return lines
}

const getEntrances = (formattedOrder, priceActions) => {
	if (formattedOrder) {
		function getKey(orderLine) {
			return orderLine.date + ";" + orderLine.details[0].zoneId
		}
		const data = {}
		const orderLines = getEntranceLines(formattedOrder)

		if (orderLines && orderLines.length > 0) {
			orderLines.forEach(orderLine => {
				let key = getKey(orderLine)

				//is used as a priceaction
				let isUsedAsPriceAction =
					(orderLine.details[0].typeId === ORDER_LINE_TYPES.Ticket ||
						orderLine.details[0].typeId === ORDER_LINE_TYPES.Object ||
						orderLine.details[0].typeId === ORDER_LINE_TYPES.ObjectGroup) &&
					(priceActions || []).find(e => e.scanCode === orderLine.details[0].scanCode)
				if (!isUsedAsPriceAction) {
					if (data[key]) {
						data[key].data.push({
							...orderLine,
							details: orderLine.details,
						})
					} else {
						data[key] = {
							date: new Date(key.split(";")[0]),
							zoneId: Number(key.split(";")[1]),
							data: [
								{
									...orderLine,
									details: orderLine.details,
								},
							],
						}
					}
				}
			})
		}
		return data
	}
}

export default function Entrances({ formattedOrder, onAction, deletable }) {
	const priceActions = useSelector(state => state.order.priceActions)
	const entrances = getEntrances(formattedOrder, priceActions)
	const {
		data: { orderOverviewEntranceTitle },
	} = useGetStrings(undefined, { defaultData: {} })

	if (entrances && Object.keys(entrances).length > 0) {
		return (
			<>
				<h2 className="f4 regular"> {orderOverviewEntranceTitle} </h2>
				<Separator />

				{Object.keys(entrances).map((key, index) => {
					return (
						<Entrance
							date={entrances[key].date}
							orderLines={entrances[key].data}
							key={index}
							onAction={onAction}
							deletable={deletable}
							zoneId={entrances[key].zoneId}
						/>
					)
				})}
			</>
		)
	}
}
